export const isCsDashboard = (REACT_APP_CS_DASHBOARD_VALID_URLS) => {
  const validUrls =
    REACT_APP_CS_DASHBOARD_VALID_URLS && REACT_APP_CS_DASHBOARD_VALID_URLS.split(',');
  const [subdomain] = window.location.hostname.split('.');
  return (validUrls || []).includes(subdomain);
};

export const generateStaticOverviewData = overviewData => {
  const data = {
    salesforce: {
      title: 'Salesforce',
      count: 0,
      configuredSync: 0,
      notConfiguredSync: 0,
    },
    hubSpot: {
      title: 'HubSpot',
      count: 0,
      configuredSync: 0,
      notConfiguredSync: 0,
    },
    marketo: {
      title: 'Marketo',
      count: 0,
      configuredSync: 0,
      notConfiguredSync: 0,
    },
  };

  Object.keys(overviewData).forEach(ovrData => {
    data[ovrData].configuredSync = overviewData[ovrData].configuredSync;
    data[ovrData].notConfiguredSync = overviewData[ovrData].notConfiguredSync;
    data[ovrData].count = overviewData[ovrData].total;
  });

  return data;
};

export const generateDynamicOverviewData = overviewData => {
  const data = {
    salesforce: {
      activelySync: {
        title: 'Actively syncing',
        count: 0,
      },
      notActivelySync: {
        title: 'Not actively syncing',
        count: 0,
      },
      syncWithError: {
        title: 'Sync with error',
        count: 0,
      },
    },
    hubSpot: {
      activelySync: {
        title: 'Actively syncing',
        count: 0,
      },
      notActivelySync: {
        title: 'Not actively syncing',
        count: 0,
      },
      syncWithError: {
        title: 'Sync with error',
        count: 0,
      },
    },
    marketo: {
      activelySync: {
        title: 'Actively syncing',
        count: 0,
      },
      notActivelySync: {
        title: 'Not actively syncing',
        count: 0,
      },
      syncWithError: {
        title: 'Sync with error',
        count: 0,
      },
    },
  };

  Object.keys(overviewData).forEach(ovrData => {
    data.salesforce[ovrData].count = overviewData[ovrData].salesforce;
    data.hubSpot[ovrData].count = overviewData[ovrData].hubSpot;
    data.marketo[ovrData].count = overviewData[ovrData].marketo;
  });

  return data;
};
